import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQ = [
  { q: "What does ₹1,249 actually get me?",
    a: "20+ service redemptions — 3 free washes, 2 free AC check-ups, free wheel alignment, free cabin filter cleaning, ₹500 off denting × 2, 100% off labour on a general service, and more. Total retail value: ₹11,800+." },
  { q: "Is it valid for 1 car or 2?",
    a: "Up to 2 cars under one membership — perfect for family. Just add both registration numbers in your dashboard after payment." },
  { q: "How long is the package valid?",
    a: "365 days from date of purchase. Use coupons any time within the year." },
  { q: "How do I redeem?",
    a: "Show your coupon code at AutoHQ (Ranigunj). Or claim it on WhatsApp before your visit. We deduct from your wallet automatically." },
  { q: "Are the parts genuine?",
    a: "Yes. 100% OEM/genuine parts across all brands — Maruti, Hyundai, Tata, Honda, Toyota, Kia, Mahindra and more." },
  { q: "Can I get a refund?",
    a: "Unused coupons can be refunded within 7 days of purchase (used coupon value deducted). Contact us on WhatsApp." },
  { q: "Is this a one-time payment or a subscription?",
    a: "One-time ₹1,249. No auto-renewal. You're in full control." },
  { q: "Is my payment secure?",
    a: "Yes — secured by Razorpay (RBI-licensed gateway). We never see or store your card details." },
];

function Item({ q, a, open, onClick, idx }) {
  return (
    <div className="border-b border-[#E4E4E7]" data-testid={`cp-faq-item-${idx}`}>
      <button
        onClick={onClick}
        className="w-full flex items-center justify-between text-left py-5 hover:opacity-80"
        data-testid={`cp-faq-toggle-${idx}`}
      >
        <span className="font-semibold text-[#0A0A0A] text-base pr-4">{q}</span>
        <ChevronDown className={`w-5 h-5 shrink-0 transition-transform text-[#71717A] ${open ? "rotate-180" : ""}`} />
      </button>
      {open && <p className="pb-5 text-sm text-[#52525B] leading-relaxed">{a}</p>}
    </div>
  );
}

export default function CPFaq() {
  const [open, setOpen] = useState(0);
  return (
    <section data-testid="cp-faq" className="bg-white text-[#0A0A0A] px-5 lg:px-8 py-16 sm:py-20">
      <div className="max-w-3xl mx-auto">
        <p className="text-[11px] uppercase tracking-[0.28em] text-[#D4AF37] font-bold">Frequently Asked</p>
        <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight">
          Got questions? Good — we have answers.
        </h2>
        <div className="mt-8">
          {FAQ.map((f, i) => (
            <Item key={i} idx={i} q={f.q} a={f.a} open={open === i} onClick={() => setOpen(open === i ? -1 : i)} />
          ))}
        </div>
      </div>
    </section>
  );
}
